import script from "./DailyDeliveryProduct.vue?vue&type=script&lang=ts&setup=true"
export * from "./DailyDeliveryProduct.vue?vue&type=script&lang=ts&setup=true"

import "./DailyDeliveryProduct.vue?vue&type=style&index=0&id=1c2cfcc7&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c2cfcc7"]])

export default __exports__